namespace CDN {

    //Used logging to print time since script loaded.
    let start = new Date();

    //Find the cdn.js host
    let scriptUrl = [].slice.call(document.getElementsByTagName('script')).map(x => x.getAttribute('src')?.toLowerCase() ?? "").find(x => x.indexOf("/cdn.js") >= 0);
    var pathArray = scriptUrl.split('/');
    var protocol = pathArray[0];
    var host = pathArray[2];
    export let cdnUrl = protocol + '//' + host + "/";

	export type VectorMapConfig = {
		url: string;
	}

	export type RasterMapConfig = {
		urls: string[];
		type: string;
	}

	export type SatelliteMapConfig = {
		urls: string[];
	}

	export type MapConfig = {
		vector: VectorMapConfig;
		raster: RasterMapConfig;
		satellite: SatelliteMapConfig;
	}

	export type Config = {
		version: string;
		apiUrl: string;
        crmApiUrl: string;
		reportUrl: string;
    };

	export let configAsync = new Promise<Config>((resolve, reject) => {
		let domainRegExp = new RegExp("\(https://[^/]*/\).*")
		let cdnDomain = document.querySelector("script[src*='cdn.js']").getAttribute('src').match(domainRegExp)[1]
		fetch(cdnDomain + "config.json?_v=" + Math.random())
			.then(response => response.json()
				.then(config => resolve(config['api'])));
	});

	export let mapConfigAsync = new Promise<MapConfig>((resolve, reject) => {
        let domainRegExp = new RegExp("\(https://[^/]*/\).*")
        let cdnDomain = document.querySelector("script[src*='cdn.js']").getAttribute('src').match(domainRegExp)[1]
        fetch(cdnDomain + "config.json?_v=" + Math.random())
			.then(response => response.json()
				.then(config => {
					let mapConfig = config['map'];
					let c: MapConfig = {
						vector: {
							url: mapConfig['vector']['url']
						},
						raster: {
							urls: mapConfig['raster']['urls'],
							type: mapConfig['raster']['type']
						},
						satellite: {
							urls: mapConfig['satellite']['urls'],
						}
					};
					return resolve(c);
				})
			);
	});

    export enum Verbosity {
        None = 0,
        OnError = 1,
        OnAllRequirementsMet = 3,
        Onload = 4,
        OnLoading = 5,
        OnCall = 6,
        All = 100,
    }

    let verbosity: Verbosity = parseInt(document.currentScript.getAttribute("verbosity") ?? Verbosity.All + "");

    export enum PackageCode {
        //Fonts
        Font_MaterialSymbols = 200,

        //Third Party
        Toastr = 300,
		Bootstrap = 301,
		Popper = 302,
		BootstrapSelect = 303,

        //Jquery
        JQuery = 100,
        JQuery_UI = 101,
        JQuery_Flot = 150,
        JQuery_FlotCrosshair = 151,
        JQuery_FlotFillBetween = 152,
        JQuery_FlotImage = 153,
        JQuery_FlotNavigate = 154,
        JQuery_FlotPie = 155,
        JQuery_FlotResize = 156,
        JQuery_FlotSelection = 157,
        JQuery_FlotStack = 158,
        JQuery_FlotSymbol = 159,
        JQuery_FlotThreshold = 160,
        JQuery_FlotTime = 161,
		JQuery_DataTables = 162,
		JQuery_AutoComplete = 163,
		JQuery_TinyMCE = 164,

        //Common
        Common = 2000,
        Component = 2001,

        //Api
        API_Shared = 2500,
        API_CameraPlayer_v1 = 2510,
        API_User_v1 = 2511,
        API_AutoComplete_v1 = 2512,
        API_Communicator_v1 = 2513,
        API_Fuel_v1 = 2514,
        API_Vehicle_v1 = 2515,
        API_Vehicle_Position_v1 = 2516,
        API_Vehicle_Health_v1 = 2517,
        API_Area_v1 = 2518,
        API_GSM_v1 = 2519,
        API_Download_v1 = 2520,
        API_Camera_v1 = 2521,
        API_Asset_v1 = 2522,
        API_Account_v1 = 2523,
        API_Driver_v1 = 2524,
        API_VehicleUser_v1 = 2525,
        API_Collection_v1 = 2526,
		API_Recovery_v1 = 2527,
        API_CRM_v1 = 2528,
        API_SoftwareApplication_v1 = 2529,
        API_Icon_v1 = 2530,
        API_Report_V1 = 2531,
		API_MapRouting_v1 = 2532,
		API_MapSet_v1 = 2533,
        API_FootageDownload_v1 = 2534,

        //Controls
        Control_Gantt = 5000,
        Control_PlaybackController = 5100,
        Control_Login = 5101,
        Control_MediaRecorder = 5102,
        Control_ProgressBar = 5103,
        Control_ProgressManager = 5104,
        Control_TimeLine = 5105,
        Control_HorizontalDateTimePicker = 5106,
        Control_IconMenu = 5107,
        Control_Angular_Accordion = 5108,
        Control_Dialog = 5109,
        Control_DownloadList = 5110,
        Control_DataTable = 5111,
        Control_FlexBox = 5112,
        Control_TabbedPane = 5113,
        Control_Permission_User = 5114,
        Control_Collection = 5115,
		Control_DataTable_JQuery = 5116,

        //Controls-UI
        Control_UI_HelpIcon = 5200,
        Control_UI_ToggleSwitch = 5201,
        Control_UI_Input = 5202,
        Control_UI_Icon = 5203,
        Control_UI_DropDown = 5204,
        Control_UI_TimePicker = 5205,
        Control_UI_DatePicker = 5206,
        Control_UI_DateTimePicker = 5207,
        Control_UI_GridSelect = 5208,
        Control_UI_CycleSelect = 5209,
        Control_UI_Button = 5210,
        Control_UI_MonthPicker = 5211,
        Control_UI_Spinner = 5212,
        Control_UI_PanelSpinner = 5213,
        Control_UI_CheckBox = 5214,
		Control_UI_ToggleButtonArray = 5215,
		Control_UI_SearchSelect = 5216,

        Control_Charts_Pie = 5300,

        //Camera Components
        Camera_Player = 6100,
        Camera_FrameRequestor = 6200,
        Camera_RequestManager = 6201,

        //Communicator Components
        Communicator = 6500,

        //Data
        DataCache = 7000,
        DataTree = 7001,
        DataRangeIndexer = 7002,

        //Map
        Map = 8000,
		MapTowers = 8001,
		WebMap = 8002,
		WebMapV1 = 8003,

        Drawing = 9000,
    }

    export enum LoadState {
        NotRequired = 0,
        Required = 1,
        Loading = 2,
        Loaded = 3,
    }

    export type cdnAlreadyLoadedFn = () => boolean;

    export interface PackageParameters extends PackageDescriptor {
        name: string;
        resources: Resource[];
        alreadyLoaded?: cdnAlreadyLoadedFn;
        beforeLoadAsync?: () => Promise<any>;
        afterLoadAsync?: () => Promise<any>;
    }

    type cdnCallback = () => any;

    export interface PackageDescriptor {
        code: PackageCode;
        version?: string;
    }

    export enum ResourceType {
        JavaScript = 1,
        Css = 2,
    }

    export interface ResourceDescriptor {
        type: ResourceType,
        path: string,
    }

    //Encapsulates the source path, type (javascript, css etc.) and load state of a particular requirement
    class Resource {
        private _type: ResourceType;
        private _path: string;
        private _loadState: LoadState = LoadState.NotRequired;
        private static _nextOrder: number = 0;
        private _order: number;
        private _onLoadPromise: Promise<void>;
        private _onLoadResolver: (value: void | PromiseLike<void>) => any;

        constructor(type: ResourceType, path: string, options?: { bootstrap?: boolean, onLoaded?: (resource: Resource) => any }) {
            this._type = type;
            this._path = path;

            this._onLoadPromise = new Promise<void>(resolve => {
                this._onLoadResolver = resolve;
            });

            if (options?.onLoaded)
                this._onLoadPromise.then(_ => {
                    options.onLoaded(this);
                });
            if (options?.bootstrap) {
                this._loadState = LoadState.Required;
                this._order = -1;
            }
        }

        get type() {
            return this._type;
        }

        get path() {
            return this._path;
        }

        get loadState() {
            return this._loadState;
        }

        set loadState(value: LoadState) {
            if (value == null) return;
            if (value == LoadState.Loading && this._loadState) return;
            this._loadState = value;
        }

        get order() {
            return this._order;
        }

        public require() {
            if (this._loadState == LoadState.NotRequired) {
                this._loadState = LoadState.Required;
                this._order = Resource._nextOrder++;
            }
        }

        public async loadedAsync() {
            await this._onLoadPromise;
        }

        public async loadAsync() {
            if (this._loadState == LoadState.Loaded || this._loadState == LoadState.Loading) return;
            this._loadState = LoadState.Loading;
            switch (this.type) {
                case ResourceType.JavaScript:
                    //Fetch the required script source path if not already loaded
                    await this._loadScriptAsync();
                    this._onLoadResolver();
                    break;
                case ResourceType.Css:
                    var cssId = hash(this.path);
                    if (!document.getElementById("" + cssId)) {
                        try {
                            await this._loadStyleSheetAsync(this.path);

                            this._loadState = LoadState.Loaded;
                            this._onLoadResolver();
                            log(Verbosity.Onload, `${this.path} loaded.`);

                            /*TODO awaiting this breaks things*/
                            //this.loadStyleSheetAsync(this.path).then(result => {

                            //    this._loadState = LoadState.Loaded;
                            //    for (let callback of this._resourceLoadedCallbacks) {
                            //        callback?.(this);
                            //    }
                            //    CallManager.checkCallbacks();
                            //    log(Verbosity.Onload, `${this.path} loaded.`);
                            //})
                            //    .catch(e => {
                            //        console.error("Falied to load " + this.path);
                            //        console.error(e);
                            //    });
                        }
                        catch (error) {
                            console.error(error);
                        }
                    }
                    else {
                        this._loadState = LoadState.Loaded;
                        this._onLoadResolver();
                        log(Verbosity.All, `${this.path} already loaded.`);
                    }
                    break;
            }
        }

        private async _loadStyleSheetAsync(path: string): Promise<boolean> {
            return new Promise((resolve, reject) => {
                let head = document.getElementsByTagName('head')[0];
                let link = document.createElement('link');
                link.onload = () => resolve(true);
                link.onerror = (e) => reject(e);
                link.setAttribute('href', path);
                link.setAttribute('rel', 'stylesheet');
                link.setAttribute('type', 'text/css');
                head.appendChild(link);  // insert the link node into the DOM and start loading the style sheet

                //Protection against never calling onload or onerror
                setTimeout(() => reject(new Error('Css Load Timeout')), 5000);
            });
        }

        private async _loadScriptAsync() {
            let self = this;

            return new Promise((resolve, reject) => {
                let scriptElement: HTMLScriptElement;
                let loaded = false;

                scriptElement = document.createElement('script');
                scriptElement.setAttribute('async', 'false');
                scriptElement.setAttribute('defer', 'false');
                scriptElement.type = 'text/javascript';
                scriptElement.onerror = (e) => {
                    log(Verbosity.OnError, `Failed to load ${encodeURI(this.path)} `);
                    reject(e);
                };
                scriptElement.onload = (<any>scriptElement).onreadystatechange = function () {
                    //log(Verbosity.All, this.readyState); //uncomment this line to see which ready states are called.
                    if (!loaded && (!this.readyState || this.readyState == 'complete')) {
                        loaded = true;
                        log(Verbosity.Onload, `${encodeURI(self.path)} loaded.`);
                        self._loadState = LoadState.Loaded;

                        self._onLoadResolver();
                        resolve(true);
                    }
                };
                scriptElement.src = this.path;
                let firstScriptElement: HTMLScriptElement = document.getElementsByTagName('script')[0];
                firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
            });
        }
    }

    export class ResourceLibrary {
        private static _resources: Resource[] = [];
        private static _loading = false;
        private static _allRequirementsLoadedPromise: Promise<void>;

        //Add a requirement to the library
        public static register(resource: Resource): Resource {
            let existingRequirement = ResourceLibrary._resources.find(l => l.type == resource.type && l.path == resource.path);
            if (existingRequirement) return existingRequirement;
            ResourceLibrary._resources.push(resource);
            return resource;
        }

        public static get(resource: ResourceDescriptor): Resource {
            for (let res of this._resources) {
                if (resource.path == res.path) return res;
            }
            return null;
        }

        public static getNextResourceToLoad(): Resource {
            //find the lowest order resource required but not loading or loaded
            let resourceToLoad: Resource = null;
            for (let r = 0; r < this._resources.length; r++) {
                let resource = this._resources[r];
                if (resource.loadState == LoadState.Required &&
                    (resourceToLoad == null || resource.order < resourceToLoad.order))
                    resourceToLoad = resource;
            }
            return resourceToLoad;
        }

        public static async allLoadedAsync() {
            /* If we are already in the process of loading required resources,
                wait for that process to complete,
                otherwise, start a new call to load the required resources */
            if (this._allRequirementsLoadedPromise == null)
                this._allRequirementsLoadedPromise = this._loadRequiredResourcesAsync();
            await this._allRequirementsLoadedPromise;
            // Mark the process as completed
            this._allRequirementsLoadedPromise = null;
        }

        private static async _loadRequiredResourcesAsync() {
            log(Verbosity.All, `Checking for next resource to load.`);

            //Fetch the next not loaded requirement from the stack
            let resource: Resource;
            while ((resource = ResourceLibrary.getNextResourceToLoad()) != null) {
                log(Verbosity.OnLoading, `Loading ${encodeURI(resource.path)}...`);
                await resource.loadAsync();
            }

            log(Verbosity.All, `All requirements loaded.`);
		}
    }

    //Package - encapsulates all requirements for a particular version of a package
    export class Package {
        private _parameters: PackageParameters;
        private _resources: Resource[] = [];
        private _ready: boolean = false;
        private _priority: number;
        private static s_lastPriority = 0;

        constructor(parameters: PackageParameters) {
            this._parameters = {
                code: parameters.code,
                name: parameters.name,
                version: parameters.version ?? "",
                resources: parameters.resources,
                alreadyLoaded: parameters.alreadyLoaded ?? (() => false),
                beforeLoadAsync: parameters.beforeLoadAsync ?? (async () => { }),
                afterLoadAsync: parameters.afterLoadAsync ?? (async () => { this._ready = true; }),
            };

            for (let requirement of parameters.resources) {
                this._resources.push(ResourceLibrary.register(requirement));
            }
        }

        get code() {
            return this._parameters.code;
        }

        get name() {
            return this._parameters.name;
        }

        get IsDefault() {
            return this._parameters.version == "";
        }

        get version() {
            return this.IsDefault ? "(default version)" : this._parameters.version;
        }

        get resources(): Resource[] {
            return this._resources;
        }

        public getNextNotLoadedRequirement(): Resource {
            for (let resource of this._resources) {
                if (resource.loadState == LoadState.NotRequired)
                    return resource;
            }
            return null;
        }

        get alreadyLoaded() {
            return this._parameters.alreadyLoaded;
        }

        get ready() {
            return this._ready;
        }

        public getRequirement(descriptor: ResourceDescriptor) {
            return this._parameters.resources.find(r => r.type == descriptor.type && r.path == descriptor.path);
        }

        public addRequirement(resource: Resource) {
            if (!this._parameters.resources.find(r => r.type == resource.type && r.path == resource.path))
                this._parameters.resources.push(resource);
            ResourceLibrary.register(resource);
        }

        //Returns the lowest loading state of all requirements
        get loadState(): LoadState {
            let loadstate = LoadState.Loaded;
            if (this.alreadyLoaded == null || !this.alreadyLoaded()) {
                for (let resource of this._resources) {
                    if (resource.loadState < loadstate)
                        loadstate = resource.loadState;
                }
            }
            return loadstate;
        }

        public async requireAsync() {
            if (this.alreadyLoaded?.()) {
                log(Verbosity.Onload, `Package ${this._parameters.name} already loaded.`);
                return;
            }

            this._priority = ++Package.s_lastPriority;

            await this._parameters.beforeLoadAsync?.();

            //Inform all related resources that they are required
            for (let resourceOuter of this._resources) {
                resourceOuter.require();
            }

            await Promise.all(this._resources.map(r => r.loadedAsync()));

            log(Verbosity.OnAllRequirementsMet, `All requirements met for package ${this._parameters.name}`);
            await this._parameters.afterLoadAsync?.();
        }
    }

    //Maintains a list of all packages available via the CDN
    class PackageLibrary {
        private static _packages: Package[] = [];

        public static addPackage(pkg: Package) {
            let existingPkg = this._packages.find(p => p.code == pkg.code && (p.version == pkg.version || pkg.version == null && p.IsDefault));
            //If the script code has not been added previous, add it
            if (existingPkg == null) {

                this._packages.push(pkg);
            }
        }

        public static alreadyLoaded(pkg: PackageDescriptor): boolean {
            return this.getPackage(pkg).alreadyLoaded();
        }

        public static getPackage(pkg: PackageDescriptor): Package | undefined {
            return this._packages.find(p => p.code == pkg.code &&
                (p.version == pkg.version ||
                    pkg.version == null && p.IsDefault));
        }

        public static getPackagesByRequirement(path: string): Package[] {
            return this._packages.filter(l => l.getRequirement({
                path: path,
                type: ResourceType.JavaScript,
            }) != null);
        }
    }

    //Utility function for logging based on level set by the consumers cdn script element's verbosity attribute.
    //E.g. <script type="text/javascript" src="https://localhost:7213/shared/scripts/cdn.js" verbosity="6">
    function log(level: Verbosity, log: any) {
        if (verbosity >= level) {
            let now = new Date();
            let timeSinceStart = now.getTime() - start.getTime();
            //let hours = timeSinceStart / 10000;
            //let minutes = time.getMinutes() + "";
            let milliseconds = timeSinceStart + "ms";

            if (typeof log === "string") {
                if (level == Verbosity.OnError) {
                    console.error(`${milliseconds} ${log}`);
                } else {
                    console.debug(`${milliseconds} ${log}`);
                }
            }
            else {
                if (level == Verbosity.OnError) {
                    console.error(milliseconds + ":");
                    console.error(log);
                } else {
                    console.debug(milliseconds + ":");
                    console.debug(log);
                }
            }
        }
    }

    function hash(path: string) {
        let hash = 0, i, chr;
        if (path.length === 0) return hash;
        for (i = 0; i < path.length; i++) {
            chr = path.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };

    class TreeNode<T> {
        private _value: T;
        private _descendants: TreeNode<T>[] = [];
        public constructor(value: T) {
            this._value = value;
        }

        public addChild(value: T) {
            let childNode = new TreeNode<T>(value);
            this._descendants.push(childNode);
            return childNode;
        }

        get descendants(): TreeNode<T>[] {
            return this._descendants;
        }
        get value(): T {
            return this._value;
        }

        public recurseFind(findFn: (value: T) => boolean): TreeNode<T>[] {
            let nodes: TreeNode<T>[] = [];
            if (findFn(this._value)) {
                nodes.push(this);
            }
            for (let d of this._descendants) {
                nodes.concat(d.recurseFind(findFn));
            }
            return nodes;
        }

        public recurseFindFirst(findFn: (value: T) => boolean): TreeNode<T> {
            if (findFn(this._value)) {
                return this;
            }
            for (let d of this._descendants) {
                let tnode = d.recurseFindFirst(findFn);
                if (tnode != null) return tnode;
            }
            return null;
        }
    }

    function _getCaller() {
        let caller = '';
        let stack = new Error().stack.split("\n");
        for (let s = stack.length - 1; s >= 0; s--) {
            if (stack[s].indexOf('/cdn.js') !== -1) continue;
            caller = stack[s].replace(/(\s)*at(\s)*(.*):([0-9]+)/, "$3:$4");
            break;
        }
        return caller;
    }

    export function requireOnce(packages: PackageDescriptor | PackageDescriptor[], allRequirementsMetCallback?: cdnCallback) {
        let caller = _getCaller();
        configAsync.then(config => {
            populateCdnPackages(config);
            requireOnceAsync(packages, caller)
                .then(packages => {
                    allRequirementsMetCallback?.();
                });
        });
    }

    export async function requireOnceAsync(descriptors: PackageDescriptor | PackageDescriptor[], caller?: string): Promise<Package[]> {
        try {
            if (!packagesRegistered) populateCdnPackages(await configAsync);

            caller ??= _getCaller();

            if (verbosity >= Verbosity.OnCall) {
                log(Verbosity.OnCall, `CDN.requireonce called from ${caller}`);
                log(Verbosity.All, descriptors);
            }

            if (!Array.isArray(descriptors)) descriptors = [descriptors];
            this._caller = caller;

			let packages: Package[] = [];
            let loadRequirementTasks: Promise<void>[] = [];
			for (let pkgDesc of descriptors) {
				let pkg: Package | undefined = PackageLibrary.getPackage(pkgDesc);
                if (pkg == null) {
                    log(Verbosity.OnError, `Can't find package ${pkgDesc}`);
                    continue;
                }
				log(Verbosity.OnCall, `Package ${pkg.name} required by Call ${caller}....`);
				packages.push(pkg);
                loadRequirementTasks.push(pkg.requireAsync());
            }

			await ResourceLibrary.allLoadedAsync();
            await Promise.all(loadRequirementTasks);

            return packages;
        }
        catch (err) {
            console.error(err);
        }
    }

    //Expose ability to register scripts if other sites want to use CDN.requireOnce
    export function addPackageToLibrary(pkg: Package) {
        PackageLibrary.addPackage(pkg);
    }
    export function setVerbosity(verbosityLvl: Verbosity) {
        verbosity = verbosityLvl;
    }

    function registerFonts(config: Config) {
        let loadState = 0 /*Not loaded*/;

        //The font files are served without a Cache-Control header, so browsers cache them
        //heuristically and never pick up newly added glyphs. The vendor index.css can't help:
        //its @font-face src is a relative url, and a query string on a stylesheet does not
        //propagate to relative urls inside it. So we emit the css ourselves with a versioned
        //font url. Bump FONT_VERSION whenever the woff2 files change.
        const FONT_VERSION = "2026.10.09";
        const fontCss = [["Outlined", "outlined"], ["Rounded", "rounded"], ["Sharp", "sharp"]].map(([family, file]) => `
            @font-face {
                font-family: "Material Symbols ${family}";
                font-style: normal;
                font-weight: 100 700;
                font-display: block;
                src: url("${cdnUrl}lib/material-symbols/material-symbols-${file}.woff2?_v=${FONT_VERSION}") format("woff2");
            }
            .material-symbols-${file} {
                font-family: "Material Symbols ${family}";
                font-weight: normal;
                font-style: normal;
                font-size: 24px;
                line-height: 1;
                letter-spacing: normal;
                text-transform: none;
                display: inline-block;
                white-space: nowrap;
                word-wrap: normal;
                direction: ltr;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                text-rendering: optimizeLegibility;
                font-feature-settings: "liga";
            }`).join("\n");

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Font_MaterialSymbols,
            name: "fonts.materialsymbols",
            //No vendor stylesheet - the css is injected in beforeLoadAsync so the font url can be versioned
            resources: [],
            alreadyLoaded: () => loadState != 0 /*Not Loaded*/,
            beforeLoadAsync: async () => {
                if (loadState != 0 /*Not Loaded*/) return;
                loadState = 1 /*Loading*/;
                console.debug("Hiding material icons while css loads");
                var style = document.createElement("style");
                style.id = "cdn-loading-material-symbols";
                document.head.appendChild(style);
                style.innerHTML = `
                    .material-symbols-outlined { opacity: 0; }
                    .material-symbols-rounded { opacity: 0; }
                    .material-symbols-sharp { opacity: 0; }`;

                var fontStyle = document.createElement("style");
                fontStyle.id = "cdn-material-symbols";
                fontStyle.innerHTML = fontCss;
                document.head.appendChild(fontStyle);
            },
            afterLoadAsync: async () => {
                if (loadState == 2/*Loaded*/) return;
                loadState = 2;

                //Wait for font to be available
                let timeout = 120000;
                let start = new Date().getTime();


                let checkFont = () => {
                    setTimeout(() => {
                        //If we exceed the timeout print error message
                        if (new Date().getTime() - start > timeout) {
                            console.error(`Failed to load the Material Symbols Font within ${timeout}ms.`);                            
                            return;
                        }
                        //If the font exists, show, otherwise check again in 200ms
                        if (document.fonts.check("48px Material Symbols Outlined")) {
                            console.debug("Unhiding material symbols");
                            var style = document.head.querySelector("#cdn-loading-material-symbols");
                            document.head.removeChild(style);
                        }
                        else checkFont();
                    }, 200);
                };

                checkFont();
            }
        }));
    }

    function registerJQueryPackages(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery,
            name: "jquery",
            alreadyLoaded: () => (<any>window).jQuery,
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/jquery-1.7.1.min.js?_v=2024.05.08.1`),
            ],
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery,
            name: "jquery",
            version: "1.7.1",
            alreadyLoaded: () => (<any>window).jQuery,
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/jquery-1.7.1.min.js?_v=2024.05.08.1`),
            ],
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery,
            name: "jquery",
            version: "3.6.0",
            alreadyLoaded: () => (<any>window).jQuery,
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/jquery-3.6.0.min.js?_v=2024.05.08.1`),
            ],
		}));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_UI,
            name: "jquery.ui",
            alreadyLoaded: () => (<any>window).jQuery?.ui,
            resources: [
				new Resource(ResourceType.Css, `${cdnUrl}jquery/ui/jquery-ui-1.7.1.custom.css?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/ui/jquery-ui-1.8.6.min.js?_v=2024.05.08.1`),
            ],
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_UI,
            name: "jquery.ui",
            version: "1.8.6",
            alreadyLoaded: () => (<any>window).jQuery?.ui,
            resources: [
				new Resource(ResourceType.Css, `${cdnUrl}jquery/ui/jquery-ui-1.7.1.custom.css?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/ui/jquery-ui-1.8.6.min.js?_v=2024.05.08.1`),
            ],
		}));
		PackageLibrary.addPackage(new Package({
			code: PackageCode.JQuery_UI,
			name: "jquery.ui",
			version: "1.12.1",
			alreadyLoaded: () => (<any>window).jQuery?.ui,
			resources: [
				new Resource(ResourceType.Css, `${cdnUrl}jquery/ui/jquery-ui-1.12.1/jquery-ui.min.css?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/ui/jquery-ui-1.12.1/jquery-ui.min.js?_v=2024.05.08.1`),
			],
		}));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_Flot,
            name: "jquery.flot",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotCrosshair,
            name: "jquery.flot.crosshair",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.crosshair.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotFillBetween,
            name: "jquery.flot.fillbetween",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.fillbetween.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotImage,
            name: "jquery.flot.image",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.image.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotNavigate,
            name: "jquery.flot.navigate",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.navigate.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotPie,
            name: "jquery.flot.pie",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.pie.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotResize,
            name: "jquery.flot.resize",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.resize.min.js?_v=2026.10.15.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotSelection,
            name: "jquery.flot.selection",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.selection.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotStack,
            name: "jquery.flot.stack",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.stack.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotSymbol,
            name: "jquery.flot.symbol",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.symbol.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotThreshold,
            name: "jquery.flot.threshold",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.threshold.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_FlotTime,
            name: "jquery.flot.time",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/flot/jquery.flot.time.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.plot?.crosshair,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_DataTables,
            name: "jquery.datatables",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/datatables/datatables-1.9.4.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}jquery/datatables/datatables-1.9.4.css?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.DataTable,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_DataTables,
            name: "jquery.datatables",
            version: "1.13.4",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/datatables/datatables-1.13.4.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}jquery/datatables/datatables-1.13.4.min.css?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.DataTable,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.JQuery_DataTables,
            name: "jquery.datatables",
            version: "1.9.4",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/datatables/datatables-1.9.4.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}jquery/datatables/datatables-1.9.4.css?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).jQuery?.DataTable,
		}));
		PackageLibrary.addPackage(new Package({
			code: PackageCode.JQuery_AutoComplete,
			name: "jquery.autocomplete",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/autocomplete/jquery-ui.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}css/autocomplete/jquery-ui.css?_v=2024.05.08.1`),
			],
			alreadyLoaded: () => (<any>window).jQuery?.AutoComplete,
		}));
		PackageLibrary.addPackage(new Package({
			code: PackageCode.JQuery_TinyMCE,
			name: "jquery.richtexteditor",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/tinymce/tinymce.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/tinymce/jquery.tinymce.min.js?_v=2024.05.08.1`),
			],
			alreadyLoaded: () => (<any>window).jQuery?.RichTextEditor,
		}));
    }

    function registerAPIControllers(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Shared,
            name: "api.shared",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/shared/shared.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => false,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_CameraPlayer_v1,
            name: "api.camera.player.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/camera/sharedenums.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/camera/cameraplayer.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.CameraPlayer?.v1,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Camera_v1,
            name: "api.camera.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/camera/sharedenums.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/camera/camera.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.CameraPlayer?.v1,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_User_v1,
            name: "api.user.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/user/user.v1.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/user/usergroup.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.User?.v1,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_AutoComplete_v1,
            name: "api.autocomplete.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/autocomplete/autocomplete.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.AutoComplete?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Communicator_v1,
            name: "api.communicator.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/communicator/communicator.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Communicator?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Fuel_v1,
            name: "api.fuel.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/fuel/fuel.v1.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/fuel/storagetank.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Fuel?.StorageTank?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Vehicle_v1,
            name: "api.vehicle.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/vehicle/vehicle.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Vehicle?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Vehicle_Position_v1,
            name: "api.vehicle.position.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/vehicle/vehicle.position.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Vehicle?.Position?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Vehicle_Health_v1,
            name: "api.vehicle.health.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/vehicle/vehicle.health.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Vehicle?.Health?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Download_v1,
            name: "api.download.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/download/download.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Download?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Area_v1,
            name: "api.area.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/area/area.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Area?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_GSM_v1,
            name: "api.gsm.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/gsm/gsm.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.GSM?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Download_v1,
            name: "api.download.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/download/download.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Download?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Asset_v1,
            name: "api.asset.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/asset/asset.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Asset?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Account_v1,
            name: "api.account.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/account/account.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Account?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Driver_v1,
            name: "api.driver.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/driver/driver.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.CameraPlayer?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_VehicleUser_v1,
            name: "api.vehicleuser.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/vehicleuser/vehicleuser.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.VehicleUser?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Collection_v1,
            name: "api.collection.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/collection/collection.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Collection?.v1,
        }));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.API_Recovery_v1,
			name: "api.recovery.v1",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}api/recovery/recovery.v1.js?_v=${config.version}`),
			],
			alreadyLoaded: () => (<any>window).CDN?.API?.Recovery?.v1,
		}));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.API_CRM_v1,
			name: "api.crm.v1",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}api/crm/crm.v1.js?_v=${config.version}`),
			],
			alreadyLoaded: () => (<any>window).CDN?.API?.CRM?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_SoftwareApplication_v1,
            name: "api.softwareapplication.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/softwareapplication/softwareapplication.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.SoftwareApplication?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Icon_v1,
            name: "api.icon.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/icon/icon.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Icon?.v1,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_Report_V1,
            name: "api.report.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/report/report.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.Report?.v1,
        }));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.API_MapRouting_v1,
			name: "api.maprouting.v1",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}api/map/maprouting.v1.js?_v=${config.version}`),
			],
			alreadyLoaded: () => (<any>window).CDN?.API?.MapRouting?.v1,
		}));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.API_MapSet_v1,
			name: "api.mapset.v1",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}api/map/mapset.v1.js?_v=${config.version}`),
			],
			alreadyLoaded: () => (<any>window).CDN?.API?.MapSet?.v1,
		}));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.API_FootageDownload_v1,
            name: "api.footagedownload.v1",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}api/camera/footagedownload.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.API?.FootageDownload?.v1,
        }));
    }

    function registerControls(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Gantt,
            name: "control.gantt",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/gantt/scripts/gantt.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/gantt/styles/gantt.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Gantt,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_PlaybackController,
            name: "control.playbackcontroller",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}shared/styles/glyphicon.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/playbackcontroller/styles/playbackcontroller.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/playbackcontroller/scripts/playbackcontroller.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.PlaybackController,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Login,
            name: "control.login",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/login/styles/login.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/login/scripts/login.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Login,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_MediaRecorder,
            name: "control.mediarecorder",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/mediarecorder/scripts/mediarecorder.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.MediaRecorder,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_DropDown,
            name: "control.ui.dropdown",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/dropdown/styles/dropdown.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/dropdown/scripts/dropdown.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.DropDown,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_TimePicker,
            name: "control.ui.timepicker",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/timepicker/styles/timepicker.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/timepicker/scripts/timepicker.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.TimePicker,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_DatePicker,
            name: "control.ui.datepicker",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/datepicker/styles/datepicker.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/datepicker/styles/datepicker.input.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/datepicker/scripts/datepicker.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/datepicker/scripts/datepicker.input.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.DateTime?.DatePicker && (<any>window).CDN?.Controls?.UI?.DateTime?.DatePickerInput,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_DateTimePicker,
            name: "control.ui.datetimepicker",
			resources: [
				new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/datetimepicker/styles/datetimepicker.css?_v=${config.version}`),
				new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/datetimepicker/styles/datetimepicker.input.css?_v=${config.version}`),
				new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/datetimepicker/styles/datetimepicker.range.css?_v=${config.version}`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/datetimepicker/scripts/datetimepicker.js?_v=${config.version}`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/datetimepicker/scripts/datetimepicker.input.js?_v=${config.version}`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/datetimepicker/scripts/datetimepicker.range.js?_v=${config.version}`),
            ], 
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.DateTime?.DateTimePicker &&
                (<any>window).CDN?.Controls?.UI?.DateTime?.DateTimePickerInput &&
                (<any>window).CDN?.Controls?.UI?.DateTime?.DateRangePicker,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_ProgressBar,
            name: "control.progressbar",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/progressbar/styles/progressbar.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/progressbar/scripts/progressbar.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.ProgressBar,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_ProgressManager,
            name: "control.progressmanager",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}shared/styles/glyphicon.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/progressmanager/styles/progressmanager.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/progressmanager/scripts/progressmanager.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.ProgressManager,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_TimeLine,
            name: "control.timeline",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}shared/styles/glyphicon.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/timeline/styles/timeline.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/timeline/scripts/timeline.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.TimeLine,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_HorizontalDateTimePicker,
            name: "control.horizontaldatetimepicker",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/horizontaldatetimepicker/styles/horizontaldatetimepicker.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/horizontaldatetimepicker/scripts/horizontaldatetimepicker.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.DateTime?.HorizontalDateTimePicker,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_IconMenu,
            name: "control.iconmenu",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/iconmenu/styles/iconmenu.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/iconmenu/scripts/iconmenu.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.IconMenu,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Angular_Accordion,
            name: "control.accordion",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/runtime.angular.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/polyfills.angular.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/scripts.angular.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/main.angular.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/accordion/styles/styles.angular.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/accordion.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/vehicleaccordion.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/accordion/scripts/areaaccordion.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/accordion/styles/accordion.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `https://fonts.googleapis.com/icon?family=Material+Icons`)
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Accordion,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Dialog,
            name: "control.dialog",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/dialog/scripts/dialog.button.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/dialog/scripts/dialog.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/dialog/scripts/dialog.message.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/dialog/scripts/dialog.confirm.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/dialog/styles/dialog.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Dialog?.Button &&
                (<any>window).CDN?.Controls?.Dialog?.Dialog &&
                (<any>window).CDN?.Controls?.Dialog?.ConfirmDialog &&
                (<any>window).CDN?.Controls?.Dialog?.MessageDialog,
            afterLoadAsync: async () => {
                /* The dialog button has to asynchronously wait for the requirements before extending the Button control */
                await (<Promise<void>>__cdn_dialog_button_defined);
            },
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_DownloadList,
            name: "control.downloadlist",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/downloadlist/scripts/downloadlist.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/downloadlist/styles/downloadlist.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.DownloadList,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_DataTable,
            name: "control.datatable",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/datatable/styles/datatable.v1.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/datatable/scripts/datatable.v1.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.DataTable,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_FlexBox,
            name: "control.layout.flexbox",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/layout/flexbox/styles/flexbox.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/layout/flexbox/scripts/flexbox.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Layout?.FlexBox,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_TabbedPane,
            name: "control.layout.tabbedpane",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/layout/tabbedpane/styles/tabbedpane.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/layout/tabbedpane/scripts/tabbedpane.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Layout?.TabbedPane,
		}));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.Control_DataTable_JQuery,
			name: "control.datatable",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/datatable/js/jquery.dataTables.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}controls/datatable/scripts/datatable.js?_v=${config.version}`),
				new Resource(ResourceType.Css, `${cdnUrl}jquery/datatable/css/jquery.dataTables.css?_v=2024.05.08.1`),
			],
			alreadyLoaded: () => (<any>window).CDN?.Controls?.DataTable.JQuery,
		}));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Permission_User,
            name: "control.permission.userpermissions",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/usergroup.manager.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/usergroup.groupmanager.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/usergroup.membermanager.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/usergroup.rolemanager.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/vehicle.user.settings.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/user.vehicle.settings.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/permission/styles/usergroup.manager.vehicle.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/usergroup.manager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/usergroup.groupmanager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/usergroup.membermanager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/usergroup.rolemanager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/usergroup.manager.vehicle.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/vehicle.user.settings.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/permission/scripts/user.vehicle.settings.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Permission?.UserGroupManager &&
                (<any>window).CDN?.Controls?.Permission?.UserGroupRoleManager &&
                (<any>window).CDN?.Controls?.Permission?.UserVehicleSettingsManager &&
                (<any>window).CDN?.Controls?.Permission?.VehicleUserSettingsManager,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Collection,
            name: "control.collection",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/collection/styles/collection.manager.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/collection/styles/collection.vehicle.manager.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/collection/scripts/collection.collectionitem.manager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/collection/scripts/collection.itemcollection.manager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/collection/scripts/collection.manager.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/collection/scripts/collection.vehicle.collectionitem.manager.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Collection?.CollectionManager &&
                (<any>window).CDN?.Controls?.Collection?.CollectionItemManager &&
                (<any>window).CDN?.Controls?.Collection?.ItemCollectionManager,
        }));
    }

    function registerControlsUI(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_HelpIcon,
            name: "control.ui.helpicon",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/helpicon/scripts/helpicon.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/helpicon/styles/helpicon.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.HelpIcon,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_ToggleSwitch,
            name: "control.ui.toggleswitch",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/toggleswitch/scripts/toggleswitch.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/toggleswitch/styles/toggleswitch.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.ToggleSwitch,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_Input,
            name: "control.ui.input",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/input/scripts/input.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/input/styles/input.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.NumericInput,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_Icon,
            name: "control.ui.icon",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/icon/styles/icon.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/icon/scripts/icon.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.Icon,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_GridSelect,
            name: "control.ui.gridselect",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/gridselect/scripts/gridselect.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/gridselect/styles/gridselect.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.GridSelect,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_CycleSelect,
            name: "control.ui.cycleselect",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/cycleselect/scripts/cycleselect.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/cycleselect/styles/cycleselect.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.CycleSelect,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_Button,
            name: "control.ui.button",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/button/scripts/button.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/button/styles/button.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.Button,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_MonthPicker,
            name: "control.ui.monthpicker",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/monthpicker/styles/monthpicker.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/monthpicker/styles/monthpicker.input.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/datetime/monthpicker/styles/monthpicker.range.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/monthpicker/scripts/monthpicker.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/monthpicker/scripts/monthpicker.input.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/datetime/monthpicker/scripts/monthpicker.range.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.Button,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_Spinner,
            name: "control.ui.spinner",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/spinner/scripts/spinner.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/spinner/styles/spinner.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.Spinner,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_PanelSpinner,
            name: "control.ui.panelspinner",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/panelspinner/scripts/panelspinner.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/panelspinner/styles/panelspinner.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.PanelSpinner,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_CheckBox,
            name: "control.ui.checkbox",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/checkbox/scripts/checkbox.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/checkbox/styles/checkbox.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.CheckBox,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_UI_ToggleButtonArray,
            name: "control.ui.togglebuttonarray",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/togglebuttonarray/scripts/togglebuttonarray.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/ui/togglebuttonarray/styles/togglebuttonarray.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.ToggleButtonArray,
		}));
		PackageLibrary.addPackage(new Package({
			code: PackageCode.Control_UI_SearchSelect,
			name: "control.ui.searchselect",
			resources: [
				new Resource(ResourceType.Css, `${cdnUrl}controls/ui/searchselect/styles/searchselect.css?_v=${config.version}`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}controls/ui/searchselect/scripts/searchselect.js?_v=${config.version}`),
			],
			alreadyLoaded: () => (<any>window).CDN?.Controls?.UI?.SearchSelect,
		}));
    }

    function registerControlsCharts(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Control_Charts_Pie,
            name: "control.chart.pie",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}controls/charts/piechart/scripts/piechart.js?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}controls/charts/piechart/styles/piechart.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Controls?.Charts?.PieChart,
        }));
    }

    function registerCameraComponents(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Camera_Player,
            name: "camera.player",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}camera/player/styles/player.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}camera/player/scripts/groupcontroller.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}camera/player/scripts/overlaymessage.v1.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}camera/player/scripts/player.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Camera?.Player,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Camera_FrameRequestor,
            name: "camera.framerequestor",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}camera/framerequestor/styles/framerequestor.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}shared/styles/elipsis.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}camera/framerequestor/scripts/framerequestor.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Camera?.FrameRequestor,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Camera_RequestManager,
            name: "camera.requestmanager",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}camera/requestmanager/styles/requestmanager.css?_v=${config.version}?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}camera/requestmanager/scripts/requestmanager.js?_v=${config.version}?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Camera?.RequestManager,
        }));
    }

    function registerCommunicatorComponents(config: Config) {

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Communicator,
            name: "communicator.communicator",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}shared/styles/glyphicon.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}communicator/styles/communicator.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}communicator/scripts/communicator.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Communicator,
        }));
    }

    function registerThirdPartyPackages(config: Config) {

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Toastr,
            name: "thirdparty.toastr",
            resources: [
				new Resource(ResourceType.Css, `${cdnUrl}lib/toastr/toastr.min.css?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/toastr/toastr.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}extensions/toastr/toastr.ext.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).toastr?.showAlert,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Bootstrap,
            name: "thirdparty.bootstrap",
            resources: [
				new Resource(ResourceType.Css, `${cdnUrl}lib/bootstrap/dist/css/bootstrap.css?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}lib/bootstrap/dist/css/bootstrap-grid.css?_v=2024.05.08.1`),
                //new Resource(ResourceType.Css, `${cdnUrl}lib/bootstrap/dist/css/bootstrap-reboot.css?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}lib/bootstrap/dist/css/bootstrap-utilities.css?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/bootstrap/dist/js/bootstrap.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).bootstrap,
		}));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.Popper,
			name: "thirdparty.popper",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}jquery/popper.min.js?_v=2024.05.08.1`),
			],
			alreadyLoaded: () => (<any>window).popper,
		}));

		PackageLibrary.addPackage(new Package({
			code: PackageCode.BootstrapSelect,
			name: "thirdparty.bootstrapselect",
			resources: [
				new Resource(ResourceType.Css, `${cdnUrl}lib/bootstrap-select/bootstrap-select.min.css?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/bootstrap-select/bootstrap-select.min.js?_v=2024.05.08.1`),
			],
			alreadyLoaded: () => (<any>window).bootstrapselect,
		}));
    }

    function registerDataManagers(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.DataCache,
            name: "data.cache",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/data/cache.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Data?.CacheSeries,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.DataTree,
            name: "data.tree",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/data/tree.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Data?.Tree,
        }));

        PackageLibrary.addPackage(new Package({
            code: PackageCode.DataRangeIndexer,
            name: "data.rangeindexer",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/data/rangeindexer.min.js?_v=2024.05.08.1`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Data?.RangeIndexer,
        }));
    }

    function registerDrawing(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Drawing,
            name: "drawing",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}drawing/scripts/arc.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Drawing?.Arc,
        }));
    }

    function registerMap(config: Config) {
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Map,
            name: "map",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/maplibre-gl.js?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/mapbox-gl-draw.js?_v=2024.05.08.1`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/mapinterfaces.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/map.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/drawcontrol.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/drawstyle.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/drawpolygoncontrol.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/drawdirectedlinecontrol.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/drawlabelcontrol.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/drawpointcontrol.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/testdrawpolygon.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/testdrawdirectedline.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}map/scripts/testmapvehicle.js?_v=${config.version}`),
				new Resource(ResourceType.Css, `${cdnUrl}map/styles/maplibre-gl.css?_v=2024.05.08.1`),
				new Resource(ResourceType.Css, `${cdnUrl}map/styles/mapbox-gl-draw.css?_v=2024.05.08.1`),
                new Resource(ResourceType.Css, `${cdnUrl}map/styles/map.css?_v=${config.version}`)
            ],
            alreadyLoaded: () => (<any>window).CDN?.Map,
        }));
        PackageLibrary.addPackage(new Package({
            code: PackageCode.MapTowers,
            name: "maptowers",
            resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/jquery-3.6.0.min.js?_v=2024.05.08.1`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}lib/minify/jquery/autocomplete/jquery-ui.min.js?_v=2024.05.08.1`),
                new Resource(ResourceType.Css, `${cdnUrl}css/autocomplete/jquery-ui.css?_v=${config.version}`),
                new Resource(ResourceType.Css, `${cdnUrl}map/styles/testtowers.css?_v=${config.version}`),
            ],
            alreadyLoaded: () => (<any>window).CDN?.MapTowers,
		}));
		PackageLibrary.addPackage(new Package({
			code: PackageCode.WebMap,
			name: "webmap",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}webmap/scripts/webmap.js?_v=${config.version}`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}webmap/scripts/OpenLayers-custom-2.12_b.js?_v=2024.09.01.1`),
			],
			alreadyLoaded: () => (<any>window).CDN?.MapTowers,
		}));
		PackageLibrary.addPackage(new Package({
			code: PackageCode.WebMapV1,
			name: "webmapv1",
			resources: [
				new Resource(ResourceType.JavaScript, `${cdnUrl}webmap/scripts/webmap.v1.js?_v=${config.version}`),
				new Resource(ResourceType.JavaScript, `${cdnUrl}webmap/scripts/OpenLayers-custom-2.12_b.js?_v=2024.09.01.1`),
				new Resource(ResourceType.Css, `${cdnUrl}webmap/styles/webmap.v1.css?_v=${config.version}`),
			],
			alreadyLoaded: () => (<any>window).CDN?.MapTowers,
		}));
    }

    //Register packages in the library
    let packagesRegistered = false;
    function populateCdnPackages(config: Config) {
        if (packagesRegistered) return;

        //Register bootstrap components first
        PackageLibrary.addPackage(new Package({
            code: PackageCode.Component,
            name: "component",
            resources: [
                new Resource(ResourceType.JavaScript, `${cdnUrl}shared/scripts/component.js?_v=${config.version}`, {
                    bootstrap: true,
                }),
            ],
            alreadyLoaded: () => (<any>window).CDN?.Component,
        }));

        registerJQueryPackages(config);

        PackageLibrary.addPackage(new Package({
            code: PackageCode.Common,
            name: "common",
            resources: [
                new Resource(ResourceType.Css, `${cdnUrl}shared/styles/common.css?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}shared/scripts/string.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}shared/scripts/date.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}shared/scripts/collection.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}shared/scripts/promise.js?_v=${config.version}`),
                new Resource(ResourceType.JavaScript, `${cdnUrl}shared/scripts/common.js?_v=${config.version}`),
            ],
            alreadyLoaded: () => "".padLeft && new Date().format && Array.groupBy && (<any>window).CDN?.Common?.PromiseState && (<any>window).CDN?.Common?.ForeignKey,
        }));

        registerFonts(config);
        registerAPIControllers(config);
        registerDataManagers(config);
        registerControls(config);
        registerControlsUI(config);
        registerControlsCharts(config);
        registerCameraComponents(config);
        registerCommunicatorComponents(config);
        registerThirdPartyPackages(config);
        registerMap(config);
        registerDrawing(config);

        packagesRegistered = true;
    }
}